import { useQuery } from '@apollo/client'
import { GetClientCartItemCountsDocument } from '@shared/gql/document-nodes'

export const useClientCartTotalCount = (): number => {
  const { data } = useQuery(GetClientCartItemCountsDocument)
  return data?.cartItems?.reduce((count, item) => count + item.itemCount, 0) ?? 0
}
